import http from '@/utils/http';
const base_path = '/v2/tool/component';

/**
 * 获取组件列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getComponentListApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};

/**
 * 删除组件接口
 * @param {string} component_id 组件ID
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const deleteComponentApi = (component_id, params) => {
  return http.delete({
    url: `${base_path}/${component_id}`,
    params,
  });
};

/**
 * 创建组件接口
 * @param {Object} data body数据
 * @returns {Promise<Object>}
 */
export const createComponentApi = (data) => {
  return http.post({
    url: base_path,
    data,
  });
};

/**
 * 同步组件接口
 * @param {Object} params Query参数
 * @returns {Promise<Object>}
 */
export const pullComponentApi = (params) => {
  return http.get({
    url: `${base_path}/pull`,
    params,
  });
};
